import { SxProps } from "@mui/material";

import { theme } from "../../mui-customs/Theme";

export const modal: SxProps = {
  display: "grid",
  placeItems: "center",
};
export const root: SxProps = {
  backgroundColor: theme.whiteBg.WBG1,
  padding: { xs: 0, sm: 4 },
  borderRadius: 2,
  position: "relative",
  minWidth: "300px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const titleContainer: SxProps = {
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  justifyContent: "center",
  pb: 3,
};

export const closeIcon: SxProps = {
  position: "absolute",
  right: { xs: "10px", md: "30px" },
  display: { xs: "none", md: "block" },
};

export const title: SxProps = {
  color: `${theme.black[800]} !important`,
  width: "fit-content",
};

export const controllerContainer: SxProps = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  mt: 2,
  gap: { xs: 0, md: 2 },
  width: "100%",
};

export const buttonContainer: SxProps = {
  display: "flex",
  gap: 2,
  mt: 2,
  width: "100%",
};

export const addImageButtonContainer: SxProps = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  mb: 1,
};

export const addImageIconButton: SxProps = {
  p: 2,
};
export const addImageIcon: SxProps = {
  color: theme.grey1[300],
  fontSize: "30px",
};
